@if (business; as biz) {
  <header class="bph">
    <div class="bph-top">
      @if (biz.logoUrl) {
        <img [src]="biz.logoUrl" [alt]="'Logo de ' + biz.name" class="bph-logo" loading="lazy" />
      } @else {
        <div class="bph-logo bph-initials" aria-hidden="true">{{ getInitials() }}</div>
      }
      @if (biz.businessTypeName) {
        <p class="bph-type">{{ biz.businessTypeName }}</p>
      }
    </div>

    <h1 class="bph-name">{{ biz.name }}</h1>

    <div class="bph-status" role="status">
      <span class="bph-dot" [class.is-open]="isOpen" aria-hidden="true"></span>
      <span>
        <strong>{{ isOpen ? 'Abierto ahora' : 'Cerrado ahora' }}</strong>
        @if (todayHours) {
          <span class="bph-hours">Hoy {{ todayHours }}</span>
        } @else {
          <span class="bph-hours">Hoy no atiende</span>
        }
      </span>
    </div>

    @if (biz.description) {
      <p class="bph-description">{{ biz.description }}</p>
    }

    @if (biz.address) {
      <a
        [href]="getGoogleMapsUrl()"
        target="_blank"
        rel="noopener noreferrer"
        class="bph-address"
        aria-label="Ver dirección en Google Maps">
        <svg class="size-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        <span>{{ biz.address }}</span>
      </a>
    }
  </header>
}
